import { gql } from '@apollo/client';

export const GET_HOLDED_CONTACT_IDS = gql`
  query HoldedContactIds($country: String!) {
    holdedContactIds(country: $country) {
      status
      code
      error
      data {
        id
        name
        email
      }
    }
  }
`;
